export const SECTORS = [
  { value: "guzellik", label: "Güzellik" },
  { value: "klinik", label: "Klinik" },
  { value: "egitim", label: "Eğitim" },
  { value: "spor", label: "Spor" },
  { value: "mimarlik_mobilya", label: "Mimarlık & Mobilya" },
  { value: "eticaret", label: "E-ticaret" },
  { value: "yeme_icme", label: "Yeme & İçme" },
  { value: "diger", label: "Diğer" },
];

export const NEEDS = [
  { value: "tasarim", label: "Tasarım" },
  { value: "sosyal_medya", label: "Sosyal Medya" },
  { value: "cekim", label: "Çekim" },
  { value: "reklam", label: "Reklam" },
  { value: "haritalar", label: "Haritalar" },
  { value: "site_yazilim", label: "Site / Yazılım" },
  { value: "ozel_yazilim", label: "Özel Yazılım" },
  { value: "tam_kapsamli", label: "Tam Kapsamlı Paket" },
];

export const STATUSES = [
  {
    value: "islemde",
    label: "Sonlandı",
    dot: "bg-slate-800",
    chip: "bg-slate-100 text-slate-800 border-slate-200",
    ring: "ring-slate-800",
  },
  {
    value: "olumlu",
    label: "Olumlu",
    dot: "bg-orange-500",
    chip: "bg-orange-50 text-orange-600 border-orange-200",
    ring: "ring-orange-500",
  },
  {
    value: "olumsuz",
    label: "Olumsuz",
    dot: "bg-red-500",
    chip: "bg-red-50 text-red-600 border-red-200",
    ring: "ring-red-500",
  },
  {
    value: "anlasildi",
    label: "Anlaşıldı",
    dot: "bg-emerald-500",
    chip: "bg-emerald-50 text-emerald-700 border-emerald-200",
    ring: "ring-emerald-500",
  },
  {
    value: "aranmali",
    label: "Aranmalı",
    dot: "bg-sky-500",
    chip: "bg-sky-50 text-sky-700 border-sky-200",
    ring: "ring-sky-500",
  },
];

export const SOURCES = [
  { value: "manuel", label: "Manuel Girişler" },
  { value: "import", label: "İçe Aktarılanlar" },
];

export const sectorLabel = (v, other) => {
  if (v === "diger" && other) return `Diğer: ${other}`;
  return SECTORS.find((s) => s.value === v)?.label || v;
};

export const needLabel = (v) => NEEDS.find((n) => n.value === v)?.label || v;

export const statusMeta = (v) =>
  STATUSES.find((s) => s.value === v) || STATUSES[0];

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function toDatetimeLocal(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromDatetimeLocal(v) {
  if (!v) return null;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}
